var map = {
	"./Ace.png": 7247,
	"./Acer.png": 5540,
	"./Adiprima Suraprinta.png": 9847,
	"./Aik Moh.png": 1008,
	"./Ajinomoto.png": 253,
	"./Akebono.png": 2423,
	"./American Standard.png": 5220,
	"./Apple.png": 5709,
	"./Aqua Japan.png": 2421,
	"./Asus.png": 9901,
	"./BAP.png": 4,
	"./BBW.png": 8982,
	"./BSP.png": 398,
	"./Baby Safe.png": 3786,
	"./Beaba.png": 6958,
	"./Bernadi Utama.png": 4646,
	"./Bridgestone.png": 6223,
	"./Bridon.png": 9853,
	"./Brompton.png": 5666,
	"./Calbee Wings.png": 2873,
	"./Cannondale.png": 458,
	"./Canon.png": 5340,
	"./Chanel.png": 4406,
	"./Chatime.png": 1156,
	"./Cimory.png": 9998,
	"./Cold Stone.png": 6564,
	"./Colnago.png": 530,
	"./Columbia.png": 9417,
	"./Continental.png": 6238,
	"./Daikin.png": 7881,
	"./Dua kelinci.png": 2702,
	"./ELC.png": 5335,
	"./Eco Paper.png": 9364,
	"./Emco.png": 7921,
	"./Fitflop.png": 1971,
	"./Freeport.png": 518,
	"./Fujifilm.png": 8783,
	"./Giordano.png": 6482,
	"./Goldengres.png": 1921,
	"./Goodyear.png": 7349,
	"./Gree.png": 9524,
	"./HSP.png": 8480,
	"./Haniori.png": 795,
	"./Herbalife.png": 6489,
	"./Hermes.png": 4279,
	"./Hisense.png": 6948,
	"./Hp.png": 8225,
	"./Hush Puppies.png": 9935,
	"./Hyundai Motor.png": 6892,
	"./IMCP.png": 5602,
	"./ITTI.png": 1543,
	"./Inan.png": 789,
	"./Informa.png": 4161,
	"./JUST MISS.png": 1807,
	"./Jakarta Sereal.png": 5643,
	"./Kkv.png": 3337,
	"./Kobexindo.png": 5400,
	"./Kohler.png": 8986,
	"./Komatsu.png": 6469,
	"./Krisbow.png": 3736,
	"./LG.png": 3178,
	"./LV.png": 7635,
	"./Lava.png": 395,
	"./Lavin Paris.png": 3384,
	"./Lenovo.png": 2724,
	"./Lixil.png": 7117,
	"./Lock n Lock.png": 5365,
	"./Longmarch.png": 1074,
	"./Mamasuka.png": 5737,
	"./Matsuo.png": 3084,
	"./Maxxis.png": 6347,
	"./Mercedes.png": 8037,
	"./Mixue.png": 81,
	"./Modena.png": 3403,
	"./Mothercare .png": 2363,
	"./Mothercare.png": 2787,
	"./Nakshatra.png": 6974,
	"./Oppo.png": 1855,
	"./PT Mahugi.png": 3986,
	"./PT Sukses Investa Anugrah Propertindo.png": 4241,
	"./PT Trimulia Warnajaya.png": 7768,
	"./Pacific.png": 3248,
	"./Panasonic.png": 5659,
	"./Petrokimia Gresik.png": 197,
	"./Phillips.png": 5332,
	"./Pirelli.png": 9486,
	"./R&R Tech.png": 6303,
	"./Ricoh.png": 8218,
	"./Rolls-royce.png": 6336,
	"./SSK.png": 9148,
	"./Salomon.png": 3302,
	"./Samsung.png": 9469,
	"./Sarana Steel.png": 76,
	"./Schlumberger.png": 8202,
	"./Sharp.png": 9449,
	"./Shiseido.png": 8337,
	"./Specialized.png": 6978,
	"./Starbucks.png": 9705,
	"./Subur Anugerah Tangerang Java Indonesia.png": 3232,
	"./Surly.png": 1978,
	"./Tefal.png": 3435,
	"./Texcoms.png": 2760,
	"./The North Face.png": 6274,
	"./Tica.png": 5808,
	"./Tomica.png": 3159,
	"./Torch Ceramics.png": 5324,
	"./Toyo Tires.png": 5783,
	"./Toyota Tsusho.png": 4267,
	"./Triangle.png": 3937,
	"./Under Armour.png": 4935,
	"./Uniqlo.png": 8805,
	"./United.png": 4288,
	"./Vans.png": 9703,
	"./Vivo.png": 4795,
	"./Yokohama.png": 8608,
	"./h&m.png": 8674,
	"./oriflame.png": 9544,
	"./sociolla.png": 4559,
	"./the body shop.png": 7464,
	"./victoria secret.png": 3132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2826;